import React, { useState, useEffect } from "react";
import axios from "axios";
import { BaseUrl, systemTimeZone,excelDownloadUrl } from "../../container/BaseUrl/BaseUrl";
import {
  Button,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography,
  FormControl,
  styled,
} from "@mui/material";
import moment from "moment";
import moment2 from "moment-timezone";
import { Skeleton } from "@mui/material";
// component imported
import { toast } from "react-toastify";
import { RiErrorWarningLine } from "react-icons/ri";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";

export const FormControls = styled(FormControl)(({ theme }) => ({
  minWidth: "70px",
  width: "3%",
  backgroundColor: "#fff",
  borderRadius: "5px",
  border: "1px solid #fff",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
      boxShadow: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
export const Selects = styled(Select)(() => ({
  fontSize: "12px",
  "& .MuiSelect-select": {
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingRight: "12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
}));
export const MenuItems = styled(MenuItem)(() => ({
  fontSize: "12px",
}));

const Agentreport = () => {
  const [showfilter, setshowfilter] = useState("sidebar_filter");
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [agentdata, setAgentdata] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [multiPageVal, setMultiPageVal] = React.useState(10);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingAgentreports, setloadingAgentreports] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  useEffect(() => {
    agentReportData();
  }, [page, multiPageVal]);

  const agentReportData = async () => {
    const Credentials = { fromdate, todate, page, defaultValue };
    await axios
      .post(
        BaseUrl + "/dashboard/tasklist",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: page == 1 ? 0 : (page - 1) * multiPageVal,
          limit: multiPageVal,
          agent_id: basedOnRole.id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success == true) {
          setAgentdata(res.data.Data);
          setPagination(res.data.count);
        }
      })
      .catch((error) => {
        setShow(true);
      });
  };
  const DownloadReports = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        BaseUrl + "/dashboard/tasklistexcel",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: page == 1 ? 0 : (page - 1) * multiPageVal,
          limit: multiPageVal,
          agent_id: basedOnRole.id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );
      setIsLoading(true);
      if (response.data.status === true) {
        setIsLoading(false);
        let downloadUrl = "https://dcc.ntt.inaipi.ae/files";
        let file = excelDownloadUrl + response.data.message;
        window.open(file);

        toast.success("Agent Report Downloaded Successfully", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        setIsLoading(false);
        toast.warn("No Data Found", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      console.log(error)
      setIsLoading(false);
      toast.warn("No Data Found", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // Handle error here
    }
  };
  const handleChangeSetPage = async (event) => {
    setMultiPageVal(event.target.value);
    setPage(1);
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className="sessiontable" style={{ overflow: "hidden" }}>
      <header className="header_role ">
        <div className="conatiner-fluid">
          <nav
            className="navbar "
            style={{ paddingTop: "0px", paddingBottom: "0px" }}
          >
            <div className="container-fluid p-0">
              <div className="hed_left d-flex"></div>
              <div className="hed_right d-flex">
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <Button
                      sx={{ marginRight: "2px" }}
                      size="small"
                      variant="contained"
                      endIcon={<DownloadSimple size={18} weight="bold" />}
                      onClick={DownloadReports}
                      disabled={isLoading}
                    >
                      {isLoading ? "Downloading..." : "Download Report"}
                    </Button>
                  <Button
                    size="small"
                    variant="contained"
                    endIcon={<FunnelSimple size={18} weight="bold" />}
                    onClick={() => {
                      setshowfilter("sidebar_filter active-r");
                    }}
                  >
                    Filter
                  </Button>
                </Stack>
              </div>
            </div>
          </nav>
        </div>
      </header>

      <div className="container-fluid p-2">
        <div className="card fixed-table-card vh-79 ">
          <div className="card-body agentContactbody">
            <div className="table-responsive vhm-68">
              <table className="table table-sm  table-hover align-middle table-fixeded">
                <thead>
                  <tr>
                    <th scope="col">Agent Name</th>
                    <th scope="col">Break Time</th>
                    <th scope="col">Active Time</th>
                    <th scope="col">Outbound</th>
                    <th scope="col">Inbound</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingAgentreports ? (
                    [...Array(8)].map((_, rowIndex) => (
                      <tr key={rowIndex}>
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex}>
                            <Skeleton variant="text" width={90} height={30} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : agentdata.length > 0 ? (
                    agentdata.map((rowData, rowIndex) => {
                      var seconds = rowData.total_break_time;
                      var duration = moment.duration(seconds, "seconds");
                      var total_break_time = moment
                        .utc(duration.asMilliseconds())
                        .format("HH:mm:ss");

                      var seconds_active = rowData.total_active_time;
                      var duration_active = moment.duration(
                        seconds_active,
                        "seconds"
                      );
                      var total_active_time = moment
                        .utc(duration_active.asMilliseconds())
                        .format("HH:mm:ss");

                      return (
                        <tr key={rowData.id}>
                          <td>
                            {rowData.agent_id == null ||
                            rowData.agent_id == undefined ||
                            rowData.agent_id == ""
                              ? "--"
                              : rowData.agent_id.username}
                          </td>
                          <td>{total_break_time}</td>
                          <td>{total_active_time}</td>
                          <td>{rowData.total_completed_outbound}</td>
                          <td>{rowData.total_completed_inbound}</td>

                          <td>
                            {moment2(rowData.created_at)
                              .tz(systemTimeZone)
                              .format("l")}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <div
                          className="text-muted"
                          style={{
                            flexDirection: "column",
                            marginTop: "20%",
                            display: "flex",
                            position: "absolute",
                            left: "45%",
                            bottom: "40%",
                          }}
                        >
                          <span className="mx-auto">
                            <RiErrorWarningLine size={30} />
                          </span>
                          <span className="mx-auto">
                            <h5
                              className="text-muted mt-2"
                              style={{
                                fontFamily: "poppins",
                              }}
                            >
                              No Data Found
                            </h5>
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="card-footer rounded-0 d-flex justify-content-between">
            <div>
              {`Showing ${Math.min(
                (page - 1) * multiPageVal + 1,
                isNaN(pagination) ? 0 : pagination
              )} to ${Math.min(
                page * multiPageVal,
                isNaN(pagination) ? 0 : pagination
              )} of ${isNaN(pagination) ? 0 : pagination} entries`}
            </div>
            <div className="d-flex">
              <Typography
                className="mt-1"
                sx={{ textTransform: "capitalize", fontSize: "12px" }}
              >
                Set page
              </Typography>
              <FormControls
                className="ms-1"
                size="small"
                sx={{ textTransform: "capitalize", fontSize: "12px" }}
              >
                <Selects
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  label="multiPageVal"
                  value={multiPageVal}
                  onChange={handleChangeSetPage}
                >
                  <MenuItems value={10}>10</MenuItems>
                  <MenuItems value={20}>20</MenuItems>
                  <MenuItems value={50}>50</MenuItems>
                  <MenuItems value={100}>100</MenuItems>
                  <MenuItems value={500}>500</MenuItems>
                </Selects>
              </FormControls>
            </div>
            <Pagination
              count={Math.ceil(pagination / multiPageVal)}
              page={page}
              color="primary"
              size="small"
              style={{ float: "right" }}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <nav className={showfilter} style={{ top: "0px" }}>
        <div className="filter col-md-12 shadow p-4 ">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="mb-0">Filters</p>
            <div className="dismiss ">
              <span
                className="material-symbols-outlined"
                onClick={() => {
                  setshowfilter("sidebar_filter");
                }}
              >
                cancel
              </span>
            </div>
          </div>

          <div className="filter_form">
            <form className=" fillter_form2 " style={{ height: "75vh" }}>
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    onChange={(e) => setTodate(e.target.value)}
                    value={todate}
                    max={defaultValue}
                  />
                </div>
              </div>
            </form>
            <div className="filter_submit">
              <div className="d-flex">
                <div className="col-md-12 ps-2">
                  <button
                    type="button"
                    id="agent_filter_Submit"
                    className="btn btn-primary w-100 "
                    onClick={() => {
                      agentReportData();
                      setshowfilter("sidebar_filter");
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Agentreport;
